import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import CustomSelect from "../../../../../Elements/CustomSelect";

function MeterAlertConfigration() {

  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  const { isdarkMode } = mode;

  const { makeRequest } = useStoreUpdaterWithAPI();

  const [converterId, setConverterId] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);



  useEffect(() => {

    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_CONVERTER_DETAILS
    }).then((res) => {
      setgetFlowConverterResData(res || []);
    });

  }, []);


  const GetAlertsMetersRes=()=>{
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.TEMP_GET_ALERT_METER_DETAILS.replace(
        "{siteId}",
        converterId
      )
    }).then((res) => {
      setRowData(res || []);
    });
  }
  useEffect(() => {

GetAlertsMetersRes()

  }, [converterId]);



  const handleChangeConverterGroup = (value) => {
    setConverterId(value);
  };

  const handleEdit = (row) => {
       makeRequest({
      type: APIConstants.PUT,
      url: APIConstants.TEMP_UPDATE_ALERT_STATUS.replace("SID",converterId).replace("MID",row?.meteR_METERID)
    }).then((res) => {
    GetAlertsMetersRes()
    });

  };

  // ==========================
  // STATUS TAG
  // ==========================

  const getStatusTag = (status) => {

    const isOn = status === "ON" || status === true;

    return (
      <Tag
        color={isOn ? "green" : "red"}
        style={{
          fontWeight: 600,
          borderRadius: "6px",
          padding: "2px 10px",
          minWidth: "50px",
          textAlign: "center"
        }}
      >
        {isOn ? "ON" : "OFF"}
      </Tag>
    );
  };


  const columnDefs = useMemo(() => [

    {
      headerName: "Meter ID",
      field: "meteR_METERID",
      width: 110,
      cellStyle: { fontWeight: 600 ,justifyContent: "center"}
    },

    {
      headerName: "Meter Name",
      field: "metername",
      flex: 1,
      minWidth: 260,
            cellStyle: {
        justifyContent: "center"
      }
    },

    {
      headerName: "Status",
      field: "meterAlertStatus",
      width: 200,
      cellRenderer: ({ value }) => getStatusTag(value),
      cellStyle: {
        justifyContent: "center"
      }
    },

    {
      headerName: "Module",
      field: "module",
      width: 200,
            cellStyle: {
        justifyContent: "center"
      }
    },

    {
      headerName: "Site Name",
      field: "sitename",
      width: 250,
            cellStyle: {
        justifyContent: "center"
      }
    },

    {
      headerName: "Update",
      width: 150,
      pinned: "right",
      cellRenderer: (params) => (
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => handleEdit(params.data)}
          style={{ color: "#1677ff" }}
        />
      ),
      cellStyle: {
        justifyContent: "center"
      }
    }

  ], []);

  // ==========================
  // UI
  // ==========================

  return (

    <div className="p-4">

  
      <div className="flex justify-between mb-4">
        <h1
          className={`${isdarkMode ? "text-white" : "text-black"} text-2xl font-semibold`}
        >
          Meter Alert Configuration 
        </h1>
      </div>



      <div className="grid grid-cols-1 md:grid-cols-2 mb-4">

        <CustomSelect
          label="Converter"
          options={getFlowConverterResData}
          onSelect={handleChangeConverterGroup}
          selectedValues={converterId}
          valueKey="sitE_ID"
          nameKey="sitename"
        />

      </div>


      <div
        className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
        style={{
          height: "75vh",
          width: "100%",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",

          '--ag-header-background-color': color.themeConfig.colorPrimary,
          '--ag-header-foreground-color': '#ffffff',
          '--ag-row-hover-color': '#f5f5f5',
          '--ag-border-color': '#e5e7eb'
        }}
      >

        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={true}
          paginationPageSize={10}
          animateRows={true}
          headerHeight={46}
          rowHeight={48}
          defaultColDef={{
            sortable: true,
            filter: true,
            resizable: true,
            cellStyle: {
              display: "flex",
              alignItems: "center",
              fontSize: "13px"
            }
          }}
        />

      </div>

    </div>

  );
}

export default MeterAlertConfigration;
